export default {"src":"/_next/static/media/icon-reward-check-in.2f23615f.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};